import styled from "@emotion/styled";

/** サンプル動画を出さない場合、SEO対策でvideoタグを埋め込む必要がある。その場合に以下を使用する */
export const VideoForSeoOptimization = styled.video`
  display: none;
`;
